import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { Button, Result, Spin } from 'antd';
import { authApi } from '../auth.api';

export function VerifyEmailPage() {
  const token = new URLSearchParams(window.location.search).get('token') ?? '';

  // Modeled as a query (not a mutation) so React Query dedupes the request under
  // StrictMode's double-invoke — the single-use token is only ever spent once.
  const { isPending, isError, isSuccess } = useQuery({
    queryKey: ['verify-email', token],
    queryFn: () => authApi.verifyEmail({ token }),
    enabled: Boolean(token),
    retry: false,
    staleTime: Infinity,
    gcTime: Infinity,
  });

  if (!token) {
    return <Result status="error" title="Missing verification token" />;
  }
  if (isPending) {
    return (
      <Result icon={<Spin size="large" />} title="Verifying your email…" style={{ padding: 0 }} />
    );
  }
  if (isError) {
    return (
      <Result
        status="error"
        title="Verification failed"
        subTitle="This link is invalid or has expired."
        extra={
          <Link to="/login">
            <Button type="primary">Go to sign in</Button>
          </Link>
        }
      />
    );
  }
  return isSuccess ? (
    <Result
      status="success"
      title="Email verified"
      subTitle="Your account is now active."
      extra={
        <Link to="/login">
          <Button type="primary">Sign in</Button>
        </Link>
      }
    />
  ) : null;
}
